import { setTheme } from "theme/default/setTheme";

export const setColor_2d3033 = setTheme(({ theme }) => `color: ${theme.colors.color_2d3033}`);
